const clone = (value) => JSON.parse(JSON.stringify(value))

export function restoreDocumentFacets(state, key = 'facets') {
  const result = clone(state[`${key}ByDocument`] || {})
  for (const id of new Set([...Object.keys(state.documents || {}), ...Object.keys(state.drafts || {})]))
    result[id] = clone(state.drafts?.[id]?.bundle?.[key] ?? result[id] ?? state[key] ?? [])
  return result
}

// Work on a snapshot so deletion only affects the current Markdown bundle.
export function removeFacet(bundle, id) {
  const next = clone(bundle)
  next.facets = next.facets.filter((facet) => facet.id !== id)
  for (const node of [...next.document.units, ...next.document.paragraphs])
    for (const field of ['facets', 'facetInputs', 'semanticFacets']) if (node[field]) delete node[field][id]
  for (const field of ['facetAnalysis', 'semanticFacetAnalysis'])
    if (next.document[field]) delete next.document[field][id]
  for (const motif of next.motifs)
    for (const [slot, constraint] of Object.entries(motif.nodeFacets || {}))
      if (constraint.id === id) delete motif.nodeFacets[slot]
  return next
}
